import React from 'react';
import {
  Box,
  IconButton,
  Tooltip
} from '@mui/material';
import {
  Info as InfoIcon
} from '@mui/icons-material';
import { CodeExampleBox, TooltipContent } from './styles';

const ApiKeyUsageTooltip = () => (
  <Tooltip
    title={
      <Box>
        <TooltipContent variant="body2">
          <strong>How to use your API key:</strong>
        </TooltipContent>
        <TooltipContent variant="body2">
          Include it in the Authorization header:
        </TooltipContent>
        <CodeExampleBox>
          Authorization: apikey &lt;your_api_key&gt;
        </CodeExampleBox>
      </Box>
    }
    placement="bottom-start"
    arrow
  >
    <IconButton>
      <InfoIcon color="info" />
    </IconButton>
  </Tooltip>
);

export default ApiKeyUsageTooltip;
